








































import VueOptions from '@utils/VueOptions'

settings =
  name: 'ExperienceShow'

  vue:
    data: ->
      selectedTab: null

    computed:
      matchedRouteNames: ->
        @$route.matched.map((route) => route.name)

      tabs: ->
        [
          {
            to: 'AudienceCreativeListPage',
            slug: '',
            label: 'Experiences',
            title: 'Experiences',
            description: 'Setup your audience\'s creative experience, availability, and add activation opportunities for sponsors.',
            class: 'text-orange',
            selectedClass: 'text-white bg-orange',
            iconClass: 'far fa-rocket'
          },
          {
            to: 'VenueListPage',
            slug: 'venues',
            label: 'Venues',
            title: 'Venues',
            description: 'When and where creative audience experiences take place.',
            class: 'text-orange',
            selectedClass: 'text-white bg-orange',
            iconClass: 'fas fa-building'
          },
          # {
          #   to: 'CalendarListPage',
          #   slug: 'calendar',
          #   label: 'Calendar',
          #   title: 'Calendar',
          #   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Magna nibh et id ultrices mattis ullamcorper maecenas ut interdum.',
          #   class: 'text-orange',
          #   selectedClass: 'text-white bg-orange',
          #   iconClass: 'fas fa-calendar-alt'
          # },
          {
            to: 'SpaceListPage',
            slug: 'inventory',
            label: 'Assets',
            title: 'Assets',
            description: 'How sponsors can activate their brands to engage with your audience (aka your assets they want to purchase).',
            class: 'text-orange',
            selectedClass: 'text-white bg-orange',
            iconClass: 'fas fa-gifts'
          },
          {
            to: 'AudienceAvailabilityListPage',
            slug: 'availabilities',
            label: 'Listings',
            title: 'Listings',
            description: 'When and where creative audience experiences take place.',
            class: 'text-recess bg-recess-lightest',
            selectedClass: 'text-white bg-recess',
            iconClass: 'fas fa-clipboard-list-check'
          },
          {
            to: 'AudienceInsightsShowPage',
            slug: 'audience-insights',
            label: 'Audience Insights',
            title: 'Audience Insights',
            description: 'Understand your audience\'s behavior and preferences to optimize your creative experiences.',
            class: 'text-orange',
            selectedClass: 'text-white bg-orange',
            iconClass: 'fas fa-chart-pie-alt fa-lg'
          },
        ]

      tabBar: ->
        width = document.querySelector('.tabs-item')?.offsetWidth
        left = width * @tabs.findIndex((tab) => tab.slug is @selectedTab?.slug)
        { width, left }

    mounted: ->
      @refreshSelectedTab()

    methods:
      hiSetTab: (tab) ->
        @selectedTab = tab
        @$router.push { name: tab.to }

      refreshSelectedTab: ->
        @selectedTab = @tabs.find((tab) => tab.to in @matchedRouteNames)

      isMatchedRoute: (tab) ->
        tab.to in @matchedRouteNames

    watch:
      '$route.path': ->
        @refreshSelectedTab()

export default VueOptions.vue settings
